/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

//@ts-nocheck

import React, { useState, useEffect } from 'react';
import { useRanger } from 'react-ranger';
import { Form } from 'react-bootstrap';
import { useTheme } from '../../../../../../providers/theme';
import { AmountDisplay } from '../AmountDisplay';
import { NumberInput } from '../InputField';
import insuranceCalcConfig from '@pages/BuyInsurancePage/config/insurance-calculator.config.json';
import * as S from './styles';

export interface ICoverageProps {
  lowerBound?: number;
  upperBound?: number;
  currency?: string;
  onValueChange?(type: string, value: number): void;
  premiumType?: any;
  coverageType?: any;
  country?: string;
  initialAmount?: number;
}

export const CoverageSlider = (props: ICoverageProps) => {
  const theme = useTheme();
  const [values, setValues] = React.useState([props?.initialAmount ?? 100000]);
  const { lowerBound, upperBound, currency, country, onValueChange } = props;

  const countryFound = insuranceCalcConfig[country];
  console.log(`currency in coverage`, currency);

  const formatter = new Intl.NumberFormat(
    countryFound?.currencyFormat?.locale,
    {
      style: 'currency',
      currency: countryFound?.currencyFormat?.currency,
    }
  );

  const [policyOption, setPolicyOption] = useState({
    subTitle: 'Coverage',
    lowerBound: 100000,
    upperBound: 500000,
    stepSize: 100000,
  });

  useEffect(() => {
    if (values[0]) {
      onValueChange && onValueChange(policyOption?.subTitle, values[0]);
    }
  }, [values]);

  const { getTrackProps, handles } = useRanger({
    min: policyOption?.lowerBound,
    max: policyOption?.upperBound,
    stepSize: policyOption?.stepSize,
    values,
    onChange: setValues,
  });

  const onInputValueSubmit = (value: number) => {
    setValues([value]);
  };
  const onRadioButtonChange = (event: any) => {
    if (event.target.value === 'premium') {
      setPolicyOption({
        subTitle: 'Premium',
        lowerBound: 20,
        upperBound: 8700,
        stepSize: 100,
      });
      setValues([20]);
    } else if (event.target.value === 'coverage') {
      setPolicyOption({
        subTitle: 'Coverage',
        lowerBound: 100000,
        upperBound: 500000,
        stepSize: 100000,
      });
      setValues([100000]);
    }
  };

  return (
    <>
      <S.AmountContainer className="mb-4 mt-2">
        <AmountDisplay
          amount={formatter?.format(values[0])}
          subTitle={policyOption?.subTitle}
        />
        <span>OR</span>
        <NumberInput
          placeholder={policyOption?.subTitle}
          policyOptions={policyOption}
          currency={currency}
          // min={policyOption?.lowerBound}
          // max={policyOption?.upperBound}
          min={formatter.format(policyOption?.lowerBound)}
          max={formatter.format(policyOption?.upperBound)}
          onInputValueSubmit={onInputValueSubmit}
          value={values[0]}
        />
      </S.AmountContainer>
      <div
        {...getTrackProps({
          style: {
            height: '10px',
            background: '#0B2535',
            boxShadow: 'inset 0 1px 2px rgba(11,37,53,.8)',
            borderRadius: '2px',
          },
        })}
      >
        {handles.map(({ getHandleProps }) => (
          <button
            {...getHandleProps({
              style: {
                // backgroundImage:`url(https://i.ibb.co/hZg2h4f/umbrella.png)`,
                width: '14px',
                height: '30px',
                outline: 'none',
                borderRadius: '10%',
                background: theme?.colors?.secondary,
                border: `solid 1px ${theme?.colors?.primary}`,
              },
            })}
          />
        ))}
      </div>
      <S.PriceIndicator>
        <p>{formatter.format(policyOption?.lowerBound)}</p>
        <p>{formatter.format(policyOption?.upperBound)}</p>
      </S.PriceIndicator>
    </>
  );
};

CoverageSlider.defaultProps = {
  lowerBound: 10000,
  upperBound: 500000,
  currency: 'INR',
};
